<template>
	<div class="population-view">
		<PopulationList
			v-bind:url="url"
			v-bind:filter="filter"
			@print="setPrint">
		</PopulationList>

		<div class="detail">
			<router-view
				v-bind:url="url"
				v-bind:filter="filter"
				v-bind:print="print">
			</router-view>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import PopulationList from '@/module/population/list/List'

export default {
	name: 'filter-viewer',

	props: {
		filter: {
			type: String
		}
	},

	mounted() {
		this.loadPatients()
	},

	data() {
		return {
			label: null,
			print: null
		}
	},

	methods: {
		...mapActions('provider', [
			'loadPatients'
		]),

		setPrint(print) {
			this.print = print
		}
	},

	computed: {
		url() {
			return (this.filter == null) ? '/filter' : ('/filter/' + this.filter)
		},
		filterDefinition() {
			return {
				name: 'test filter'
			}
		}
	},

	components: {
		PopulationList
	}
}
</script>

<style lang="scss" scoped>
.list {
	width: 240px;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	float: left;
	border-right: solid 1px #dfdfdf;
	overflow-x: hidden;
}
.detail {
	height: 100%;
	overflow-y: auto;
}
.filter-view {
    padding: 10px;
    background: #fafafa;

    .el-card {
        margin-bottom: 10px;
    }
}
</style>
